import React from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Section, breakpoints } from '~styles/global'
import FAQItem from '../FAQItem';

const FAQList = ({ heading, faqs, className }) => {

  const { mobile } = breakpoints

  return (
      <Section 
        className={className} 
        css={css`
          background-color: var(--beige);
      `}>
          <div css={css`
               grid-column: span 6;
               ${ mobile } {
                grid-column: span 12;
               }
          `}>
            <h1 className="serif" css={css`
                margin-bottom: 0.7em;
            `}>{heading}</h1>
          </div>
          <div css={css`
               grid-column: span 6;
               margin-top: 1rem;
               ${ mobile } {
                grid-column: span 12;
               }
          `}>
            {faqs?.map(faq => (
              <FAQItem key={faq?._key} question={faq?.question} answer={faq?.answer} />
            ))}
          </div>
      </Section>   
  )
}

FAQList.propTypes = {
    heading: PropTypes.string,
    faqs: PropTypes.arrayOf(PropTypes.shape({
        question: PropTypes.string,
        answer: PropTypes.array,
        key: PropTypes.string,
    })),
}

FAQList.defaultProps = {
    heading: 'How can we help',
    faqs: [
        { 
          question:'question', 
          answer:[
            {
                "_key": "3ea50ebfc390",
                "_type": "block",
                "children": [
                    {
                        "_key": "323553faf1d0",
                        "_type": "span",
                        "marks": [],
                        "text": "Of course you should!"
                    }
                ],
                "markDefs": [],
                "style": "normal"
            }
          ], 
          key:"key", 
        },
        { 
          question:'question 2', 
          answer:[
            {
                "_key": "3ea50ebfc390",
                "_type": "block",
                "children": [
                    {
                        "_key": "323553faf1d0",
                        "_type": "span",
                        "marks": [],
                        "text": "Of course you should!"
                    }
                ],
                "markDefs": [],
                "style": "normal"
            }
          ], 
          key:"key1" 
        }
    ],
}

export default FAQList
